import MuiBadge from '@mui/material/Badge';

import { useBadgeVariantStyles } from './config';
import { CustomBadgeProps } from './props';

/**
 * ===========================
 * MAIN
 * ===========================
 */
export const CustomBadge: React.FC<CustomBadgeProps> = (props) => {
  const { sx, skin, color } = props;

  // =============== HOOKS
  const colors = useBadgeVariantStyles();

  // =============== VIEWS
  return (
    <MuiBadge
      {...props}
      sx={
        skin === 'light' && color
          ? Object.assign({ '& .MuiBadge-badge': colors[color] }, sx)
          : sx
      }
    />
  );
};

/**
 * ===========================
 * EXPORTS
 * ===========================
 */
export * from './props';
export default CustomBadge;
